import React, { useState } from "react";
import ResponseJSONflowone from "./bankIfscJsonSamples/ResponseJSONflowone";
import ResponseJSONflowtwo from "./bankIfscJsonSamples/ResponseJSONflowtwo";
import ResponseJSONflowthree from "./bankIfscJsonSamples/ResponseJSONflowthree";
import ResponseJSONflowfour from "./aadharVerifyJsonSamples/ResponseJSONflowfour";
import ResponseJSONflowfive from "./aadharVerifyJsonSamples/ResponseJSONflowfive";
import ResponseJSONflowsix from "./aadharVerifyJsonSamples/ResponseJSONflowsix";
import ResponseJSONflowseven from "./aadharVerifyJsonSamples/ResponseJSONflowseven";
import ResponseJSONfloweight from "./bankVerifiyJsonSamples/ResponseJSONfloweight";
import ResponseJSONflownine from "./bankVerifiyJsonSamples/ResponseJSONflownine";
import ResponseJSONflowten from "./ocrJsonSamples/ResponseJSONflowten";
import ResponseJSONfloweleven from "./ocrJsonSamples/ResponseJSONfloweleven";
import ResponseJSONflowtwelve from "./ocrJsonSamples/ResponseJSONflowtwelve";
import ResponseJSONflowelthirteen from "./ocrJsonSamples/ResponseJSONflowelthirteen";
import ResponseJSONflowfourteen from "./panVerifyJsonSamples/ResponseJSONflowfourteen";
import ResponseJSONflowfiftheen from "./panVerifyJsonSamples/ResponseJSONflowfiftheen";
import ResponseJSONflowsixteen from "./vpaVerifyJsonSamples/ResponseJSONflowsixteen";
import ResponseJSONflowseventeen from "./vpaVerifyJsonSamples/ResponseJSONflowseventeen";
import ResponseJSONflowCheckStatus1 from "./bankVerifiyJsonSamples/ResponseJSONflowCheckStatus1";
import ResponseJSONflowCheckStatus2 from "./bankVerifiyJsonSamples/ResponseJSONflowCheckStatus2";
import ResponseJSONflowCheckStatus3 from "./bankVerifiyJsonSamples/ResponseJSONflowCheckStatus3";
import ResponseJSONflowCheckStatus4 from "./panVerifyJsonSamples/ResponseJSONflowCheckStatus4";
import ResponseJSONflowCheckStatus5 from "./panVerifyJsonSamples/ResponseJSONflowCheckStatus5";
import ResponseJSONflowCheckStatus6 from "./panVerifyJsonSamples/ResponseJSONflowCheckStatus6";
import ResponseJSONflowCheckStatus7 from "./vpaVerifyJsonSamples/ResponseJSONflowCheckStatus7";
import ResponseJSONflowCheckStatus8 from "./vpaVerifyJsonSamples/ResponseJSONflowCheckStatus8";
import ResponseJSONflowCheckStatus9 from "./vpaVerifyJsonSamples/ResponseJSONflowCheckStatus9";

function VerificationSuit() {
  const [activeTab, setActiveTab] = useState(0);
  const [activeTab1, setActiveTab1] = useState(0);
  const [activeTab2, setActiveTab2] = useState(0);
  const [activeTab3, setActiveTab3] = useState(0);
  const [activeTab4, setActiveTab4] = useState(0);
  const [activeTab5, setActiveTab5] = useState(0);
  const [activeTab6, setActiveTab6] = useState(0);
  const [activeTab7, setActiveTab7] = useState(0);
  const [activeTab8, setActiveTab8] = useState(0);
  const [activeTab9, setActiveTab9] = useState(0);
  const [activeTab10, setActiveTab10] = useState(0);

  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <section id="idocs_content">
              <h1>Verification Suite</h1>
              <hr />
              <p class="mt-30" style={{ maxWidth:"650px"}}>
                Fetch customer details such as Name, Address and Photograph from
                the UIDAI database by passing Aadhaar No & OTP.
              </p>
            </section>
          </div>
          <div class="col-md-9">
            <section id="idocs_content">
              <h1 id="verification-suite-api">Verification Suite APIs</h1>
              <hr />
              <p class="mt-30" style={{ maxWidth:"650px"}}>
                Fetch customer details such as Name, Address and Photograph from
                the UIDAI database by passing Aadhaar No & OTP.
              </p>
            </section>

            <div>
              <section className="mb-30">
                <h5 className="apix-sub-heading">IFSC Validation</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>API</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>Bank IFSC Validation</td>
                      <td>
                        Use this API to search bank and branch details of the
                        given IFSC code
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section className="mb-30">
                <h5 className="apix-sub-heading">Aadhar Verification</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>API</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>Validate Aadhaar</td>
                      <td>
                        Use this API to send the Otp on aadhaar registered
                        mobile number.
                      </td>
                    </tr>
                    <tr>
                      <td>Submit Aadhaar Verification otp</td>
                      <td>
                        Use this API to get the information from the Aadhaar
                        platform to confirm the authenticity of a person's
                        identity.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section className="mb-30">
                <h5 className="apix-sub-heading">Bank Verification</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>API</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>Validate Bank</td>
                      <td>
                        Use this API to send the request for Bank Account
                        Verification
                      </td>
                    </tr>
                    <tr>
                      <td>Check Status</td>
                      <td>
                        After getting the validate Bank api response Use this
                        API to verify Bank account
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section className="mb-30">
                <h5 className="apix-sub-heading">OCR</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>API</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>Aadhaar OCR </td>
                      <td>
                        This API extracts data from aadhaar cards image
                        instantly and accurately
                      </td>
                    </tr>
                    <tr>
                      <td>PAN OCR</td>
                      <td>
                        This API extracts data from pan cards image instantly
                        and accurately
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section className="mb-30">
                <h5 className="apix-sub-heading">PAN Verification</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>API</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>Validate PAN</td>
                      <td>
                        Use this API to send the request for PAN card
                        verification
                      </td>
                    </tr>
                    <tr>
                      <td>Check Status</td>
                      <td>
                        After getting the response of Validate PAN use this API
                        to verify PAN card
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section className="mb-30">
                <h5 className="apix-sub-heading">VPA Verification</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>API</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <td>Validate VPA</td>
                      <td>
                        Use this API to send the request for VPA verification
                      </td>
                    </tr>
                    <tr>
                      <td>Check Status</td>
                      <td>
                        After getting the response of Validate VPA use this API
                        to verify VPA
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section className="mt-50">
                <h3 id="ifsc-validation-sec">Bank IFSC Validation</h3>

                <p class="mt-10">Check bank IFSC status:</p>
                <div class="rec-box">
                  <h5>Postman Collection:</h5>
                  <p className="mb-0">Validation Suite</p>
                </div>
                <div class="mt-30">
                  <h5 className="apix-sub-heading">URL</h5>

                  <h5 class="mb-0 mt-10">
                    <div
                      style={{
                        backgroundColor: "rgb(17 23 26)",
                        color: "#fff",
                      }}
                    >
                      <button className="apix-api-btn"> POST </button>{" "}
                      /v1/service/verification/ifsc
                    </div>
                  </h5>
                </div>
                <div class="mt-30">
                  <h5 className="apix-sub-heading">Headers</h5>
                  <div className="apix-headers-sec">
                    <div className="headers-divs">
                      <div>
                        <span className="txt-1">
                          Content-Type{" "}
                          <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                        </span>{" "}
                        <span className="txt-2">required</span>
                      </div>
                      <span className="txt-3">application/json</span>
                    </div>
                    <div className="headers-divs">
                      <div>
                        <span className="txt-1">
                          Authorization{" "}
                          <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                        </span>{" "}
                        <span className="txt-2">required</span>
                      </div>
                      <span className="txt-3">Basic Auth</span>
                    </div>
                    <div className="headers-divs">
                      <div>
                        <span className="txt-1">
                          Accept{" "}
                          <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                        </span>{" "}
                        <span className="txt-2">required</span>
                      </div>
                      <span className="txt-3">application/json</span>
                    </div>
                  </div>
                </div>
                <div class="mt-30">
                  <h5 className="apix-sub-heading">Body Params</h5>
                  <div className="apix-headers-sec">
                    <div className="headers-divs">
                      <div>
                        <span className="txt-1">
                          Ifsc <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                        </span>{" "}
                        <span className="txt-2">required</span>
                      </div>
                      <span className="txt-3">
                        Bank IFSC code (Max Length: 11)
                      </span>
                    </div>
                  </div>
                </div>
                <div class="mt-30">
                  <h5 className="apix-sub-heading">Request Samples</h5>
                  <div class="form-data" style={{ float: "none" }}>
                    <text
                      class="formData"
                      readonly=""
                      style={{ lineHeight: "19px" }}
                    >
                      curl --location --request POST
                      &nbsp;&nbsp;'/v1/service/verification/ifsc' \{"\n"}
                      &nbsp;&nbsp;--header 'Content-Type: application/json' \
                      {"\n"}
                      &nbsp;&nbsp;--header 'Authorization: Basic
                      e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                      &nbsp;&nbsp;--data-raw '{"{"}
                      {"\n"}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ifsc": "PYTM0123456"{"\n"}
                      &nbsp;&nbsp;{"}"}'
                    </text>
                  </div>
                </div>
                <div className="mt-30">
                  <h5 className="apix-sub-heading">Response Samples</h5>
                  <div className="mt-20">
                    <div className="apix-tabs-sec">
                      <button
                        className={`apix-tab-btn ${
                          activeTab == 0 ? "active-btn" : ""
                        }`}
                        onClick={() => setActiveTab(0)}
                      >
                        IFSC Found
                      </button>{" "}
                      <button
                        className={`apix-tab-btn ${
                          activeTab == 1 ? "active-btn" : ""
                        }`}
                        onClick={() => setActiveTab(1)}
                      >
                        IFSC Not Found
                      </button>{" "}
                      <button
                        className={`apix-tab-btn ${
                          activeTab == 2 ? "active-btn" : ""
                        }`}
                        onClick={() => setActiveTab(2)}
                      >
                        Failed
                      </button>
                    </div>
                    <div className="mt-20">
                      {activeTab == 0 && <ResponseJSONflowone />}
                      {activeTab == 1 && <ResponseJSONflowtwo />}
                      {activeTab == 2 && <ResponseJSONflowthree />}
                    </div>
                  </div>
                </div>
                <div class="mt-30">
                  <h5 className="apix-sub-heading">Response Code</h5>
                  <table class="table table-bordered mt-10">
                    <tbody>
                      <tr>
                        <th>Status Code</th>
                        <th>Status</th>
                        <th>Message</th>
                      </tr>
                      <tr>
                        <td>0x0200</td>
                        <td>SUCCESS</td>
                        <td>TRANSACTION SUCCESSFULL</td>
                      </tr>
                      <tr>
                        <td>0x0201</td>
                        <td>UNAUTHORIZED</td>
                        <td>UNAUTHORIZED USER</td>
                      </tr>
                      <tr>
                        <td>0x0202</td>
                        <td>FAILURE</td>
                        <td>FAILURE USER</td>
                      </tr>
                      <tr>
                        <td>0x0203</td>
                        <td>MISSING_PARAMETER</td>
                        <td>MISSING PARAMETER</td>
                      </tr>
                      <tr>
                        <td>0x0204</td>
                        <td>CONNECTION_TIMEOUT</td>
                        <td>CONNECTION TIMEOUT</td>
                      </tr>
                      <tr>
                        <td>0x0205</td>
                        <td>SOMETHING_WENT_WRONG</td>
                        <td>SOMETHING WENT WRONG</td>
                      </tr>
                      <tr>
                        <td>0x0206</td>
                        <td>PENDING</td>
                        <td>TRANSACTION PENDING</td>
                      </tr>
                      <tr>
                        <td>0x0208</td>
                        <td>2FA</td>
                        <td>TWO FACTOR AUNTHENTICATION</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </div>
          </div>
          <div class="col-md-9">
            <section className="mt-20">
              <div className="mb-30">
                <h1>Aadhaar Verification</h1>
                <hr />
              </div>

              <h3 id="validate-aadhar-sec">Validate Aadhaar</h3>

              <p class="mt-10">Aadhaar Validation Suite:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/aadhaar/initiate
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Aadhaar Number{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User Aadhaar Number For verification (Max Length: 12)
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/aadhaar/initiate' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"aadhaarNumber":"111122223333"
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab1 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab1(0)}
                    >
                      Success
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab1 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab1(1)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab1 == 0 && <ResponseJSONflowfour />}
                    {activeTab1 == 1 && <ResponseJSONflowfive />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="mt-50">
              <h3 id="submit-aadhar-otp-sec">Submit Aadhaar OTP</h3>

              <p class="mt-10">Submit Aadhaar OTP:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/aadhaar/otp
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        requestedId{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      You will get requestedId from the above Api response (Max
                      Length: 50)
                    </span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        otp <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      Recived the Otp on Aadhaar registered Mobile Number (Max
                      Length: 8)
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/aadhaar/otp' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"requestId":"VADR28310891589610079158",
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"otp": "582126",{"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab2 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab2(0)}
                    >
                      Success
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab2 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab2(1)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab2 == 0 && <ResponseJSONflowsix />}
                    {activeTab2 == 1 && <ResponseJSONflowseven />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div class="col-md-9">
            <section className="mt-20">
              <div className="mb-30">
                <h1>Bank Verification</h1>
                <hr />
              </div>

              <h3 id="validate-bank-sec">Validate Bank</h3>

              <p class="mt-10">BANK Account Validation Suite:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/bank/initiate
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        accountNumber{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User Bank Account Number (Max Length: 26)
                    </span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        ifsc <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User Bank IFSC Code (Max Length: 11)
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/bank/initiate' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"accountNumber":
                    "919900000000",{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"ifsc": "PYTM0123456"{"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab3 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab3(0)}
                    >
                      Success
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab3 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab3(1)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab3 == 0 && <ResponseJSONfloweight />}
                    {activeTab3 == 1 && <ResponseJSONflownine />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="mt-50">
              <h3 id="check-status-1">Check Status</h3>

              <p class="mt-10">BANK Account Validation Suite:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/bank/check
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        requestedId{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      You will get requestedId from the above API response (Max
                      Length: 50)
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/bank/check' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"requestId":"VBNK282988243721545177FD"
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab8 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab8(0)}
                    >
                      Bank Found
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab8 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab8(1)}
                    >
                      Bank Not Found
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab8 == 2 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab8(2)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab8 == 0 && <ResponseJSONflowCheckStatus1 />}
                    {activeTab8 == 1 && <ResponseJSONflowCheckStatus2 />}
                    {activeTab8 == 2 && <ResponseJSONflowCheckStatus3 />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div class="col-md-9">
            <section className="mt-20">
              <div className="mb-30">
                <h1>OCR</h1>
                <hr />
              </div>
              <h3 id="aadhar-ocr-sec">Aadhaar OCR</h3>

              <p class="mt-10">Aadhaar optical character recognition:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5>URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/ocr/aadhaar
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        clientRefId{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      Unique Reference number (Max Length: 30)
                    </span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        aadhaarFront{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User Aadhaar Card Front Copy (JPEG / PNG / JPG) (Max
                      Length: )
                    </span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        aadhaarBack{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User Aadhaar Card Back Copy (JPEG / PNG / JPG) (Max
                      Length: )
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/ocr/aadhaar' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; "clientRefId" :
                    "aadhaarIDs333",{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; "aadhaarFront":
                    "https://example.com/aadhaasrFront.jpg",{"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"aadhaarBack":
                    "https://example.com/aadhaarBack.jpg"{"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab4 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab4(0)}
                    >
                      Success
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab4 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab4(1)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab4 == 0 && <ResponseJSONflowten />}
                    {activeTab4 == 1 && <ResponseJSONfloweleven />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5>Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <section className="mt-50">
              <h3 id="pan-ocr-sec">PAN OCR</h3>

              <p class="mt-10">PAN optical character recognition:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/ocr/pan
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        clientRefId{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      Unique Reference number (Max Length: 30)
                    </span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        pan <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User Pan Card Copy (JPEG / PNG / JPG) (Max Length: )
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/ocr/pan' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; "clientRefId" : "panIDs333",
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; "pan":
                    "https://example.com/pan.jpg"{"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab5 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab5(0)}
                    >
                      Success
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab5 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab5(1)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab5 == 0 && <ResponseJSONflowtwelve />}
                    {activeTab5 == 1 && <ResponseJSONflowelthirteen />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div class="col-md-9">
            <section className="mt-20">
              <div className="mb-30">
                <h1>PAN Verification</h1>
                <hr />
              </div>
              <h3 id="pan-validate-sec">Validate Pan</h3>

              <p class="mt-10">PAN Validation Suite:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/pan/initiate
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        pan <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User Pan Card Number (Max Length: 11000)
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/pan/initiate' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; "pan": "ABCDE1234F"{"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab6 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab6(0)}
                    >
                      Success
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab6 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab6(1)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab6 == 0 && <ResponseJSONflowfourteen />}
                    {activeTab6 == 1 && <ResponseJSONflowfiftheen />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="mt-50">
              <h3 id="check-status-2">Check Status</h3>

              <p class="mt-10">PAN Check Status:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/pan/check
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        requestedId{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      You will get requestedId from the above API response (Max
                      Length: 50)
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/pan/check' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"requestId":"VPAN28335017105332100010"
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab9 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab9(0)}
                    >
                      PAN Found
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab9 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab9(1)}
                    >
                      PAN Not Found
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab9 == 2 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab9(2)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab9 == 0 && <ResponseJSONflowCheckStatus4 />}
                    {activeTab9 == 1 && <ResponseJSONflowCheckStatus5 />}
                    {activeTab9 == 2 && <ResponseJSONflowCheckStatus6 />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div class="col-md-9">
            <section className="mt-20">
              <div className="mb-30">
                <h1>VPA Verification</h1>
                <hr />
              </div>
              <h3 id="validate-vpa-sec">Validate VPA</h3>

              <p class="mt-10">VPA Validation Suite:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/vpa/initiate
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        vpa <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      User VPA Id (UPI Id) (Max Length: 100)
                    </span>
                  </div>
                </div>
              </div>

              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/vpa/initiate' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; "vpa": "vpaaddress@paytm"
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab7 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab7(0)}
                    >
                      Success
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab7 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab7(1)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab7 == 0 && <ResponseJSONflowsixteen />}
                    {activeTab7 == 1 && <ResponseJSONflowseventeen />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <section className="mt-50">
              <h3 id="check-status-3">Check Status</h3>

              <p class="mt-10">VPA Check Status:</p>
              <div class="rec-box">
                <h5>Postman Collection:</h5>
                <p className="mb-0">Validation Suite</p>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">URL</h5>
                <h5 class="mb-0 mt-10">
                  <div
                    style={{
                      backgroundColor: "rgb(17 23 26)",
                      color: "#fff",
                    }}
                  >
                    <button className="apix-api-btn"> POST </button>{" "}
                    /v1/service/verification/vpa/check
                  </div>
                </h5>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Headers</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Content-Type{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Authorization{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">Basic Auth</span>
                  </div>
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        Accept <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">application/json</span>
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Body Params</h5>
                <div className="apix-headers-sec">
                  <div className="headers-divs">
                    <div>
                      <span className="txt-1">
                        requestedId{" "}
                        <span style={{ fontWeight: 400 }}>(String)</span>{" "}
                      </span>{" "}
                      <span className="txt-2">required</span>
                    </div>
                    <span className="txt-3">
                      You will get requestedId from the above API response (Max
                      Length: 50)
                    </span>
                  </div>
                </div>
              </div>

              <div class="mt-30">
                <h5 className="apix-sub-heading">Request Samples</h5>
                <div class="form-data" style={{ float: "none" }}>
                  <text
                    class="formData"
                    readonly=""
                    style={{ lineHeight: "19px" }}
                  >
                    curl --location --request POST
                    '/v1/service/verification/vpa/check' \{"\n"}
                    &nbsp;&nbsp;--header 'Content-Type: application/json' \
                    {"\n"}
                    &nbsp;&nbsp;--header 'Authorization: Basic
                    e3tsb2NfdXNlcn19Ont7bG9jX3Bhc3N9fQ==' \{"\n"}
                    &nbsp;&nbsp;--data-raw '{"{"}
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"requestId":"VVPA28311712855182658FAE"
                    {"\n"}
                    &nbsp;&nbsp;&nbsp;{"}"}'
                  </text>
                </div>
              </div>
              <div className="mt-30">
                <h5 className="apix-sub-heading">Response Samples</h5>
                <div className="mt-10">
                  <div className="apix-tabs-sec">
                    <button
                      className={`apix-tab-btn ${
                        activeTab10 == 0 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab10(0)}
                    >
                      VPA Found
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab10 == 1 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab10(1)}
                    >
                      VPA Not Found
                    </button>{" "}
                    <button
                      className={`apix-tab-btn ${
                        activeTab10 == 2 ? "active-btn" : ""
                      }`}
                      onClick={() => setActiveTab10(2)}
                    >
                      Failed
                    </button>{" "}
                  </div>
                  <div className="mt-20">
                    {activeTab10 == 0 && <ResponseJSONflowCheckStatus7 />}
                    {activeTab10 == 1 && <ResponseJSONflowCheckStatus8 />}
                    {activeTab10 == 2 && <ResponseJSONflowCheckStatus9 />}
                  </div>
                </div>
              </div>
              <div class="mt-30">
                <h5 className="apix-sub-heading">Response Code</h5>
                <table class="table table-bordered mt-10">
                  <tbody>
                    <tr>
                      <th>Status Code</th>
                      <th>Status</th>
                      <th>Message</th>
                    </tr>
                    <tr>
                      <td>0x0200</td>
                      <td>SUCCESS</td>
                      <td>TRANSACTION SUCCESSFULL</td>
                    </tr>
                    <tr>
                      <td>0x0201</td>
                      <td>UNAUTHORIZED</td>
                      <td>UNAUTHORIZED USER</td>
                    </tr>
                    <tr>
                      <td>0x0202</td>
                      <td>FAILURE</td>
                      <td>FAILURE USER</td>
                    </tr>
                    <tr>
                      <td>0x0203</td>
                      <td>MISSING_PARAMETER</td>
                      <td>MISSING PARAMETER</td>
                    </tr>
                    <tr>
                      <td>0x0204</td>
                      <td>CONNECTION_TIMEOUT</td>
                      <td>CONNECTION TIMEOUT</td>
                    </tr>
                    <tr>
                      <td>0x0205</td>
                      <td>SOMETHING_WENT_WRONG</td>
                      <td>SOMETHING WENT WRONG</td>
                    </tr>
                    <tr>
                      <td>0x0206</td>
                      <td>PENDING</td>
                      <td>TRANSACTION PENDING</td>
                    </tr>
                    <tr>
                      <td>0x0208</td>
                      <td>2FA</td>
                      <td>TWO FACTOR AUNTHENTICATION</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationSuit;
